import { render, staticRenderFns } from "./tc-tabs.vue?vue&type=template&id=7c6b0ecc&scoped=true&"
import script from "./tc-tabs.vue?vue&type=script&lang=js&"
export * from "./tc-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b0ecc",
  null
  
)

export default component.exports